import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

export function createTokenInterceptor(apiUrl: string) {
    return (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
        const oidcSecurityService = inject(OidcSecurityService);

        return oidcSecurityService.getAccessToken().pipe(
            switchMap(accessToken => {
                const isApi = req.url.startsWith(apiUrl);

                if (!isApi || !accessToken) {
                    return next(req);
                }

                return next(withAccessToken(req, accessToken));
            })
        );
    };
}

function withAccessToken(req: HttpRequest<unknown>, accessToken: string) {
    return req.clone({
        headers: req.headers.append('Authorization', `Bearer ${accessToken}`)
    });
}
